import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { prop } from 'ramda';
import Translate from 'react-translate-component';

import ModalCloseButton from 'components/modals/ModalCloseButton';
import ModalContainer from 'components/modals/ModalContainer';
import { openModalPerson } from 'actions/modalActions';
import { DefinitionField } from 'components/common/fields/DefinitionField';
import { TimeRangeField, DateRangeField } from 'components/common/fields/DateTimeFields';
import { notEmpty } from 'utils/ramdaAdditions';

@connect(null, { openModalPerson })
export default class EducationEventModal extends Component {
    static propTypes = {
        params: PropTypes.object.isRequired,
        modal: PropTypes.object.isRequired,
        openModalPerson: PropTypes.func.isRequired,
        close: PropTypes.func.isRequired,
    }

    renderTrainers(trainers = []) {
        return trainers.map((item, index) => (
            <span key={index}>
                {this.renderPersonLink(item.trainer)}
            </span>
        ));
    }

    renderPersonLink({ id, name }) {
        const { openModalPerson } = this.props;

        return id && name && (
            <a onClick={() => openModalPerson({ id })}>
                {name}
            </a>
        );
    }

    render() {
        const { modal, close, params: { name, people, dt, place, trainers, project = {} } } = this.props;

        const footer = <ModalCloseButton close={close} />;

        return (
            <ModalContainer
                modal={modal}
                meta={{}}
                title={<Translate content="calendar.education_event"/>}
                footer={footer}
                className="education-modal modal-normal"
            >
                <div className="panel-view">
                    <DefinitionField translate="calendar.education_events_fields.name" text={name} />
                    <DefinitionField translate="calendar.education_events_fields.project" text={prop('name', people || {})} />
                    <DefinitionField translate="calendar.education_events_fields.people">
                        { this.renderPersonLink(people || {}) }
                    </DefinitionField>
                    <DefinitionField translate="calendar.education_events_fields.date">
                        <DateRangeField date={prop('date', dt || {})} />
                    </DefinitionField>
                    <DefinitionField translate="calendar.education_events_fields.time">
                        <TimeRangeField time={prop('time', dt || {})} />
                    </DefinitionField>
                    <DefinitionField translate="calendar.education_events_fields.place" text={place} />
                    <DefinitionField translate="calendar.education_events_fields.trainers" show={notEmpty(trainers)}>
                        {this.renderTrainers(trainers)}
                    </DefinitionField>
                    <DefinitionField translate="education.action.headers.project" text={project.name} />
                </div>
            </ModalContainer>
        );
    }
}
